import MarketingPageWrapper from '@/domain/Training/MarketingPageWrapper';
import MarketingHero from '@/domain/Training/MarketingHero';
import MarketingHighlightCopy from '@/domain/Training/MarketingHighlightCopy';
import MarketingContent from '@/domain/Training/MarketingContent';
import MarketingTrainers from '@/domain/Training/MarketingTrainers';
import MarketingFeatures from '@/domain/Training/MarketingFeatures';
import MarketingProgramSimple from '@/domain/Training/MarketingProgramSimple';
import MarketingTestimonials from '@/domain/Training/MarketingTestimonials';
import MarketingFAQs from '@/domain/Training/MarketingFAQs';
import MarketingContact from '@/domain/Training/MarketingContact';
import client from '@/api/client';
import { trainingQuery } from '@/api/queries';

export async function getStaticProps({ params }) {
  const { data } = await client().query({
    query: trainingQuery,
    variables: {
      id: 'official-scrum-trainer-certification-training',
    },
  });

  return {
    props: {
      training: data?.training,
    }
  }
}

export default function TrainingMarketingPage({
  training,
}) {
  if (training === null || training === undefined) {
    return null;
  }

  const hasContent = training.content !== null;
  const hasTrainers = training.details.trainers !== null;
  const hasWhatIsLearned = training.details.whatIsLearned !== null;
  const hasProgramSubjects = training.details.programSubjects !== null;
  const hasTestimonials = training.details.testimonials !== null;
  const hasFAQs = training.details.faqs !== null;

  return (
    <MarketingPageWrapper>
      <MarketingHero
        heroCopy="Official Scrum Trainer"
        heroLead={(
          <p>
            El programa de entrenamiento&nbsp;
            <strong className="text-gray-900">más completo para hispanohablantes</strong>
            &nbsp;donde adquieres y desarrollas las competencias necesarias para ejercer como un&nbsp;
            <strong className="text-gray-900">Scrum Trainer</strong>
            .
          </p>
        )}
        heroImage="w_710,h_910/v1610683720/personas/official-scrum-trainer-certification_vcylug.png"
        heroImageAlt="Official Scrum Trainer Training"
        {...training.details}
      />
      <MarketingHighlightCopy>
        <p>
          El programa&nbsp;
          <strong className="font-semibold text-white">Official Scrum Developer</strong>
          &nbsp;te capacita para convertirte en un&nbsp;
          <strong className="font-semibold text-white">Desarrollador de Scrum</strong>
          &nbsp;con las herramientas y el conocimiento para ejecutar los procesos&nbsp;
          <strong className="font-semibold text-white">Lean-Agile</strong>
          &nbsp;en cualquier organización.
        </p>
      </MarketingHighlightCopy>
      {hasContent && <MarketingContent content={training.content} />}
      {hasTrainers && (<MarketingTrainers trainers={training.details.trainers} />)}
      {hasWhatIsLearned && <MarketingFeatures features={training.details.whatIsLearned} />}
      {hasProgramSubjects && <MarketingProgramSimple program={training.details.programSubjects} />}
      {hasTestimonials && <MarketingTestimonials testimonials={training.details.testimonials} />}
      {hasFAQs && (<MarketingFAQs faqs={training.details.faqs} />)}
      <MarketingContact />
    </MarketingPageWrapper>
  );
}
